module.exports = __webpack_public_path__ + "static/nobox-red-be2ec8ef1f2c4ab3a94fac0762399998.png";